<template>
  <div class="wizard-step-persona-content">
    <div class="wizard-step-persona-content__flow" />
    <cms-rich-text :rich-text="page.richText" />
  </div>
</template>

<script>
  import CmsRichText from '@/components/cms/cms-rich-text/cms-rich-text'

  export default {
    components: { CmsRichText },
    props: {
      page: {
        type: Object,
        required: true,
      },
    },
  }
</script>

<style lang="scss" src="./_wizard-step-persona-content.scss" />
